import { cn } from '@/lib/utils'

/**
 * Loading placeholder. The shimmer is a class-based gradient over theme
 * tokens, so it follows light and dark without an inline style.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-control bg-surface-2 animate-shimmer',
        'bg-[linear-gradient(90deg,var(--color-surface-2)_0%,var(--color-line)_50%,var(--color-surface-2)_100%)] bg-[length:200%_100%]',
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
